import React, { useEffect, useState } from 'react';
import { Button, Col, Glyphicon, Row } from 'react-bootstrap';
import { Loader } from 'semantic-ui-react';

interface TradePayoffLoadingProps {
  payoffResponseLoading: boolean;
  onClose: () => void;
}

const TradePayoffLoading = (props: TradePayoffLoadingProps) => {
  const [firstLineLoading, setFirstLineLoading] = useState(true);

  useEffect(() => {
    // automatically stop showing the first spinner after 1 second
    const timer = setTimeout(() => {
      setFirstLineLoading(false);
    }, 1000);

    return () => {
      clearTimeout(timer);
    };
  });

  return (
    <div className="trade-payoff-loading-container">
      <Row>
        <h3>Looking for Trade Payoff</h3>
      </Row>
      <Row>
        <Col xs={6}>Checking customer info</Col>
        <Col xs={6}>
          {firstLineLoading ? (
            <Loader active />
          ) : (
            <Glyphicon glyph="ok" className="trade-payoff-checkmark" />
          )}
        </Col>
      </Row>
      <Row>
        <Col xs={6}>Searching for trade payoff amount</Col>
        <Col xs={6}>
          {props.payoffResponseLoading ? (
            <Loader active />
          ) : (
            <Glyphicon glyph="ok" className="trade-payoff-checkmark" />
          )}
        </Col>
      </Row>
      <Row>This should only take a few seconds...</Row>
      <Row>
        <Button onClick={props.onClose} className="btn modal-button secondary">
          Close and Continue in Background
        </Button>
      </Row>
    </div>
  );
};

export default TradePayoffLoading;
